//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAllChannel } from '@/api';
export default {
  data() {
    return {
      channels: [],
    };
  },
  mounted() {
    this.getChannel();
  },
  methods: {
    getChannel() {
      this.$axios(getAllChannel()).then(res => {
        const liveHome = res.result?.liveHome;
        if (liveHome?.children?.length) {
          liveHome.children.forEach(item => {
            if (item.id === 'liveChannel') {
              this.channels = item.children || [];
            }
          });
        }
      });
    },
  },
};
